'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AspectRatioContent = require('./AspectRatioContent');

var _AspectRatioContent2 = _interopRequireDefault(_AspectRatioContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AspectRatioContent2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/AspectRatioContent/index.js
// module id = 88
// module chunks = 11